/**
 * 分组告警API
 *
 * @Author: szs
 * @Date: 2021-10-20
 * @Last Modified time: 2021-10-20
 */

import http from '@/utils/request'
const apis = {
  // 获取分组告警列表
  getGrowthModelGroupAlarmConfigList(dto) {
    return http.get({
      url: '/pc/growthModelGroupAlarmConfig/getGrowthModelGroupAlarmConfigList',
      data: dto
    })
  },

  // 获取分组告警
  getGrowthModelGroupAlarmConfig(dto) {
    return http.get({
      url: '/pc/growthModelGroupAlarmConfig/getGrowthModelGroupAlarmConfig',
      data: dto
    })
  },
  // 获取分组告警
  getHomeDataRealAlarmList(dto) {
    return http.get({
      url: '/pc/dataAlarm/getHomeDataRealAlarmList',
      data: dto
    })
  },

  // 保存分组告警
  saveGrowthModelGroupAlarmConfig(dto) {
    return http.post({
      url: '/pc/growthModelGroupAlarmConfig/saveGrowthModelGroupAlarmConfig',
      data: dto,
      typea: 1
    })
  },

  // 删除分组告警
  delGrowthModelGroupAlarmConfig(id) {
    return http.post({
      url: '/pc/growthModelGroupAlarmConfig/delGrowthModelGroupAlarmConfig',
      data: {
        id: id,
        _method: 'delete'
      }
    })
  },

  // 获取全部告警用户信息
  getSysPushUsers(dto) {
    return http.get({
      url: '/pc/growthModelGroupAlarmConfig/getSysPushUsers',
      data: dto
    })
  },

  // 获取告警记录列表
  getGrowthModelGroupHisAlarmList(dto) {
    return http.get({
      url: '/pc/growthModelGroupAlarmConfig/getGrowthModelGroupHisAlarmList',
      data: dto
    })
  }
}
export default apis
